'use strict';

var $ = require('jquery');
var globalisation = require('../../utilities/globalisation');
var config = require('../config');

exports.customValidationError = function(value, element) {
  if ($(element).hasClass(config.classes.hasCustomValidationError)) {
    // return false because it has a custom error and is not valid
    return false;
  } else {
    // return true if it does not have the class
    return true;
  }
};

$.validator.addMethod('custom-validation-error', exports.customValidationError, globalisation.pluraliseAndTranslate('formValidation', 'customValidationError', '{0}'));

//pulled this method from additional-methods.js
$.validator.addMethod('require_from_group', function(value, element, options) {
  return validateFields.call(this, element, options, 0);
}, $.validator.format('Please fill at least {0} of these fields.'));


$.validator.addMethod('require_from_manufacture', function(value, element, options) {
  var isCheckedIncludeManufacturer = $('#IncludeManufacturer').is(':checked');
  return validateFields.call(this, element, options, 2, isCheckedIncludeManufacturer);
}, $.validator.format('Please fill at least {0} of these fields.'));


function validateFields(element, options, index, isValidToValidate = true) {
  var $fields = $(options[1], element.form),
    $fieldsFirst = $fields.eq(index),
    validator = $fieldsFirst.data('valid_req_grp') ? $fieldsFirst.data('valid_req_grp') : $.extend({}, this),
    isValid = isValidToValidate ? validator.elementValue($fields.eq(index)).length >= options[0] : true;

  // Store the cloned validator for future validation
  $fieldsFirst.data('valid_req_grp', validator);

  // If element isn't being validated, run each require_from_group field's validation rules
  if (!$(element).data('being_validated')) {
    $fields.data('being_validated', true);
    $fields.each(function() {
      validator.element(this);
    });
    $fields.data('being_validated', false);
  }

  return isValid;
}



// WEBPACK FOOTER //
// ./assets/js/validators/custom-validation-error.js